import PageCard from 'features/shared/components/card/PageCard';
import { formatBankAccount } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InvoiceDTO from '../dtos/InvoiceDTO';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import PaymentQRCode from 'features/payments/components/PaymentQRCode';
import QRPaymentDTO from 'features/payments/dtos/QRPaymentDTO';
import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import { isProductionInvoice } from '../helpers/invoiceHelper';

interface Props {
  invoice: InvoiceDTO;
  qrPayment?: QRPaymentDTO;
}

const InvoicePaymentCard = ({ invoice, qrPayment }: Props) => {
  // translations
  const { t } = useTranslation(["payments\\enums\\paymentMethodType"]);
  const tLabels = useTranslation("invoice\\invoice").t;

  // sub-renders
  const renderQRCode = () => {
    if (qrPayment) {
      return (
        <div className="col-auto pl-4">
          <PaymentQRCode qrPayment={qrPayment} size={96} />
        </div>
      );
    }
  }

  const renderPaymentAlert = () => {
    if (!isProductionInvoice(invoice.invoiceSubType!)) {
      if (invoice.unpaidAmount === 0) {
        return (
          <div className="alert alert-success p-2 mt-2 mb-0 border-0">
            <strong>{tLabels("invoicePaymentCard.dontPaid")}</strong> - {tLabels("invoicePaymentCard.paid")}
          </div>
        );
      } else if (invoice.unpaidAmount && invoice.unpaidAmount > 0) {
        return (
          <div className="alert alert-danger p-2 mt-2 mb-0 border-0 d-flex justify-content-between font-weight-bold">
            <span>{tLabels("invoicePaymentCard.remainPaid")}</span>
            <span>
              <PriceFormatter amount={invoice.unpaidAmount} currency={invoice.currency!} decimalPlaces={2} />
            </span>
          </div>
        );
      }        
    }
  }

  // render
  return (
    <PageCard title={tLabels("invoicePaymentCard.cardTitle")} >  
      <div className="row no-gutters">
        <div className="col">
          <InfoItem title={tLabels("invoicePaymentCard.paymentMethodType")} value={t(invoice.paymentMethodType || "")} />
          <div className="d-flex flex-wrap mt-sm-2">
            <div className="mr-4">
              <InfoItem title={tLabels("invoicePaymentCard.bankAccount")} value={formatBankAccount(invoice.supplierBankAccount!)} />
            </div>
            <InfoItem title={tLabels("invoicePaymentCard.variableSymbol")} value={invoice.variableSymbol} />
          </div>
        </div>
        {renderQRCode()}
      </div>
      {renderPaymentAlert()}
    </PageCard>
  )
}

export default InvoicePaymentCard;
